module.exports = __webpack_public_path__ + "img/9.02063fa5.png";